import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#6D8EFF',
      light: '#91A8FF',
      dark: '#5272E0',
    },
    secondary: {
      main: '#1E1E1E', // Темный фон
      light: '#2D2D2D',
      dark: '#141414',
    },
    background: {
      default: '#0B0D12',
      paper: '#12151C',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#9CA3AF',
    },
    divider: 'rgba(255, 255, 255, 0.09)',
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '3.5rem',
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontSize: '2.5rem',
      fontWeight: 700,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 600,
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 600,
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '0.875rem',
    },
    body1: { fontSize: '0.9375rem' },
    body2: { fontSize: '0.8125rem' },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { scrollbarColor: '#3F4654 #0B0D12' },
        '*:focus-visible': {
          outline: '2px solid #91A8FF',
          outlineOffset: 2,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 40,
          borderRadius: 8,
          padding: '8px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          borderRadius: 10,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: '1px solid rgba(255, 255, 255, 0.09)',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.24)',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 8 },
        notchedOutline: { borderColor: 'rgba(255, 255, 255, 0.12)' },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: { minWidth: 40, minHeight: 40, borderRadius: 8 },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 6, fontWeight: 600 },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderColor: 'rgba(255, 255, 255, 0.1)',
          padding: '12px 16px',
        },
        head: {
          fontWeight: 600,
          color: '#9CA3AF',
          backgroundColor: '#0F1218',
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:not(.MuiTableRow-head):hover': { backgroundColor: 'rgba(255, 255, 255, 0.025)' },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          backgroundImage: 'none',
          borderRadius: 12,
          border: '1px solid rgba(255, 255, 255, 0.09)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
          '& input:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 1000px #1E1E1E inset',
            WebkitTextFillColor: '#FFFFFF',
            transition: 'background-color 5000s ease-in-out 0s'
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: 'primary.main'
          },
          '& .MuiInputLabel-root.MuiFormLabel-filled': {
            color: 'primary.main'
          },
          '& .MuiInputLabel-root.MuiInputLabel-shrink': {
            color: 'primary.main'
          }
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '0.875rem',
          fontWeight: 600,
          minWidth: 'auto',
          minHeight: 40,
          padding: '8px 16px',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: { fontSize: '0.75rem', borderRadius: 6 },
      },
    },
  },
});
